import { AutoMap } from "@automapper/classes";

export class PrelevementQualifSalleEntity {
    Id?: number;
    @AutoMap()
    Code: string = ''
    @AutoMap()
    Observations: string = ''
    @AutoMap()
    PersonnesPresentes?: number
    @AutoMap()
    SystemeTraitementAir?: number

    @AutoMap()
    LocalisationDeSalle?: number
    @AutoMap()
    AutreLocalisationDeSalle: string = ''
    @AutoMap()
    Classe?: number
    // @AutoMap()
    // HeureDebut?: string
    @AutoMap()
    SurfaceZAC?: number
    @AutoMap()
    Volume?: number
    /** BASE 64 IMAGE */
    @AutoMap()
    Plan: string = ''
    @AutoMap()
    Temperature?: number
    @AutoMap()
    Humidite?: number
    @AutoMap()
    Luminosite?: number
    @AutoMap()
    PressionAcoustique?: number
    @AutoMap()
    TestFumee?: number

    @AutoMap()
    PourcentageAirNeuf?: number
    @AutoMap()
    Type?: number
    @AutoMap()
    ProduitDangereux: boolean = false
    
    PrelevementId?: number;
    ZoneCompareIds!: number[];
    ZoneCompareSasIds!: number[];
    SoufflageIds!: number[];
    RepriseIds!: number[];
    // AppareilIds!: number[];
}